const rightNavbar = {
  portugues: {
    menu: {
      hello: 'Olá',
      subscribe: 'ASSINE AGORA O BELLA',
      myAccount: 'Login',
      myCredits: 'Meus Créditos',
      myAccountLogado: 'Acessar minha conta',
      freetour: 'Free Tour',
      modelos: 'Modelos',
      videos: 'Vídeos',
      lives: 'Lives',
      blog: 'Blog',
      colums: 'Colunas',
      ecards: 'Ecards',
      bellacloud: 'Bella Cloud',
      sobre: 'Sobre o Bella',
      contactUs: 'Fale Conosco',
      logout: 'Sair',
      subscribe2: 'Assine agora',
      subscribe2Login: 'Faça um Upgrade',      
    }
  },
  ingles: {
    menu: {
      hello: 'Hello',
      subscribe: 'SUBSCRIBE TO BELLA NOW',
      myAccountLogado: 'Access my account',
      myAccount: 'Login',
      myCredits: 'My Credits',
      freetour: 'Free Tour',
      modelos: 'Models',
      videos: 'Videos',
      lives: 'Lives',
      blog: 'Blog',
      colums: 'Articles',
      ecards: 'eCards',
      bellacloud: 'Bella Cloud',
      sobre: 'About us',
      contactUs: 'Contact Us',
      logout: 'Logout',
      subscribe2: 'Subscribe Now',
      subscribe2Login: 'Upgrade',            
    }
  }
}

export default rightNavbar
